import {
  FETCH_LEADS_START,
  FETCH_LEADS_SUCCESS,
  FETCH_LEADS_ERROR,
  GET_LEAD_DETAILS_REQUEST,
  GET_LEAD_DETAILS_SUCCESS,
  GET_LEAD_DETAILS_FAILURE,
  UPDATE_LEAD_BRANCH_REQUEST,
  UPDATE_LEAD_BRANCH_SUCCESS,
  UPDATE_LEAD_BRANCH_FAILURE,
} from "../actions/LeadActions";

const initialState = {
  freshleads: {
    data: [],
    loading: false,
    error: null,
  },
  followupleads: {
    data: [],
    loading: false,
    error: null,
  },
  convertednomedicine: {
    data: [],
    loading: false,
    error: null,
  },
  todaysfollowups: {
    data: [],
    loading: false,
    error: null,
  },
  tomorrowfollowups: {
    data: [],
    loading: false,
    error: null,
  },
  upcomingfollowups: {
    data: [],
    loading: false,
    error: null,
  },
  leadDetails: null,
  loading: false,
  error: null,
  branchUpdateLoading: false,
  branchUpdateError: null,
};

const LeadReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LEADS_START:
      return {
        ...state,
        [action.payload.category]: {
          ...state[action.payload.category],
          loading: true,
          error: null,
        },
      };

    case FETCH_LEADS_SUCCESS:
      return {
        ...state,
        [action.payload.category]: {
          ...state[action.payload.category],
          loading: false,
          data: action.payload.data,
          error: null,
        },
      };

    case FETCH_LEADS_ERROR:
      return {
        ...state,
        [action.payload.category]: {
          ...state[action.payload.category],
          loading: false,
          error: action.payload.error,
        },
      };

    case GET_LEAD_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_LEAD_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        leadDetails: action.payload,
        error: null,
      };
    case GET_LEAD_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case UPDATE_LEAD_BRANCH_REQUEST:
      return {
        ...state,
        branchUpdateLoading: true,
        branchUpdateError: null,
      };
    case UPDATE_LEAD_BRANCH_SUCCESS:
      return {
        ...state,
        branchUpdateLoading: false,
        branchUpdateError: null,
        leadDetails: {
          ...state.leadDetails,
          branch_id: action.payload.branch_id,
        },
      };
    case UPDATE_LEAD_BRANCH_FAILURE:
      return {
        ...state,
        branchUpdateLoading: false,
        branchUpdateError: action.payload,
      };

    default:
      return state;
  }
};

export default LeadReducer;
